<template>
  <div>
    <base-header  class="pb-6 bg-danger">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Instagram Panel</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <!--          <div class="col-lg-6 col-5 text-right">-->
        <!--            <base-button size="sm" type="neutral">New</base-button>-->
        <!--            <base-button size="sm" type="neutral">Filters</base-button>-->
        <!--          </div>-->
      </div>

    </base-header>


    <div v-if="this.$store.getters.getHaveAccountInstagram" class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card>
            <add-new-configuration-instagram/>
          </card>
        </div>
      </div>
    </div>
    <div v-else class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card>
            <add-user-credentials-instagram/>
          </card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import RouteBreadCrumb from '../../components/Argon/Breadcrumb/RouteBreadcrumb';
    import addUserCredentialsInstagram
        from "../../components/YsyInstagram/addUserCredentialsInstagram";
    import addNewConfigurationInstagram
        from "../../components/YsyInstagram/addNewConfigurationInstagram";

    export default {
        name: "SetUserConfigurationInstagram",
        components: {
            addUserCredentialsInstagram,
            addNewConfigurationInstagram,
            RouteBreadCrumb,

        },
        data() {
            return {
                componentKey: 0
            }
        },
        methods: {
            forceRerender() {
                this.componentKey += 1
            }
        }
    }
</script>

<style scoped>


</style>
